<template>
  <div
    class="credit-card"
  >
    <h2 class="credit-card__title">Credit Card</h2>
    <div
      class="stripe-card__row stripe-card__row-two-col"
      :class="{ 'input-error': cardholderNameError }"
    >
      <div class="stripe-card__number-row">
        <input
          class="cardknox-ach-fields"
          placeholder="Cardholder Name"
          v-model="cardholderName"
        />
      </div>
    </div>
    <div
      class="stripe-card__row stripe-card__row-two-col"
      :class="{ 'input-error': cardExpiryError }"
    >
      <div class="stripe-card__number-row">
        <ifields
          ref="ifieldCardRef"
          :type="CARD_TYPE"
          :account=iFieldsOptions
          :options="{
            autoFormat: true,
            autoFormatSeparator: ' ',
            autoSubmit: false,
            placeholder: '1234 1234 1234 1234',
            iFieldstyle: {
              fontSize: '16px',
              backgroundColor: '#EDEDED',
              color: backgroundColor,
              border: 'none',
              outline: 'none',
            }
          }"
        />
      </div>
      <div
        class="stripe-card__row-right-col"
      >
        <input class="stripe-card__date cardknox-expiry"
               type="text"
               name="exp-date"
               inputmode="numeric"
               maxlength="5"
               placeholder="MM / YY"
               v-model="cardExpiry"
               id="expiryDate"
               v-mask="'##/##'"
               :masked="true"
        >
      </div>
    </div>
    <div
      :id="'payment-message-' + cardknoxItemID"
      v-if="hasCardError"
      class="form__error credit-card__error"
    >
      <p v-if="cardExpiryError" class="error-message">
        {{ expiryErrors[cardExpiryError] || 'The card information is invalid' }}
      </p>
    </div>
    <div
      :id="'card-error-' + cardknoxItemID"
      class="form__error credit-card__error"
    />
  </div>
</template>

<script>

import ifields, { CARD_TYPE } from '@cardknox/vue-cardknox-ifields'

export default {
  components: {
    ifields,
  },
  props: {
    iFieldsOptions: {
      type: Object,
      required: true,
    },
    cardknoxItemID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      CARD_TYPE,
      expiryErrors: {
        expired: 'Your card has expired.',
        invalid_month: 'Invalid month.',
        invalid_format: 'Invalid date format.'
      },
    }
  },
  computed: {
    backgroundColor() {
      return process.env.SECONDARY_COLOR;
    },
    hasCardError() {
      return this.cardExpiryError
    },
    cardholderName: {
      get: function () {
        return this.$store.getters['formValidation/getCreditCardField']('cardholder_name')
      },
      set: function (val) {
        this.$store.commit('formValidation/setCreditCardFormData', {
          field: 'cardholder_name',
          value: val,
        })
      }
    },
    cardExpiry: {
      get: function () {
        return this.$store.getters['formValidation/getCreditCardField']('card_expiry')
      },
      set: function (val) {
        this.$store.commit('formValidation/setCreditCardFormData', {
          field: 'card_expiry',
          value: val,
        })
      }
    },
    cardholderNameError() {
      return this.$store.getters['formValidation/getCreditCardError']('cardholder_name')
    },
    cardExpiryError() {
      return this.$store.getters['formValidation/getCreditCardError']('card_expiry')
    },
  },
}
</script>


<style lang="scss">
iframe {
  border: 0 solid transparent;
  height: 45px;
  padding: 0px;
  margin-bottom: 5px;
}

.cardknox-expiry{
  border: none;
  outline: none;
  font-size: 16px;
  background-color: #EDEDED;
  padding: 0px;
}
</style>
